<div style="padding-bottom: 30px;">
    <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead>
            <tr>
                <th class="header-cell" style="padding-left: 24px !important;">Data Source Category</th>
                <th class="header-cell right-text">State</th>
                <th class="header-cell right-text">County</th>
                <th class="header-cell right-text">City</th>
                <th class="header-cell right-text">Total</th>
            </tr>
        </thead>
        <tbody>
            <tr class="lower-height-row">
                <td colspan="5" class="table-section">Property Record Statistic</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Zoning Code records (GAPI)</td>
                <td>{{ zoningCodeRecord?.MetaData?.gapiPRsCount?.state | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.gapiPRsCount?.county | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.gapiPRsCount?.city | number}}</td>
                <td>{{ zoningCodeRecord?.MetaData?.gapiPRsCount?.total | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Cached Property Records (ZAPI)</td>
                <td>{{ zoningCodeRecord?.MetaData?.cachedPRs?.state | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.cachedPRs?.county | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.cachedPRs?.city | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.cachedPRs?.total | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Property Records left</td>
                <td>{{ zoningCodeRecord?.MetaData?.notCachedPRsCount?.state | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.notCachedPRsCount?.county | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.notCachedPRsCount?.city | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.notCachedPRsCount?.total | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Progress, %</td>
                <td ngClass="{{zoningCodeRecord?.MetaData?.prsCachingProgress?.state >= 110 ? 'red-text' : ''}}">{{
                    zoningCodeRecord?.MetaData?.prsCachingProgress?.state | number }}%</td>
                <td ngClass="{{zoningCodeRecord?.MetaData?.prsCachingProgress?.county >= 110 ? 'red-text' : ''}}">{{
                    zoningCodeRecord?.MetaData?.prsCachingProgress?.county | number }}%</td>
                <td ngClass="{{zoningCodeRecord?.MetaData?.prsCachingProgress?.city >= 110 ? 'red-text' : ''}}">{{
                    zoningCodeRecord?.MetaData?.prsCachingProgress?.city | number }}%</td>
                <td ngClass="{{zoningCodeRecord?.MetaData?.prsCachingProgress?.total >= 110 ? 'red-text' : ''}}">{{
                    zoningCodeRecord?.MetaData?.prsCachingProgress?.total | number }}%</td>
            </tr>
            <tr class="lower-height-row">
                <td colspan="5" class="table-section">Group Ids with Allowed Uses</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">GAPI</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.state?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.county?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.city?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.total?.groupIdsCount | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">ZAPI</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.state?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.county?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.city?.groupIdsCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.total?.groupIdsCount | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Difference</td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.state?.groupIdsCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.state?.groupIdsCount | number }}
                </td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.county?.groupIdsCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.county?.groupIdsCount | number }}
                </td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.city?.groupIdsCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.city?.groupIdsCount | number }}
                </td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.total?.groupIdsCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.total?.groupIdsCount | number }}
                </td>
            </tr>
            <tr class="lower-height-row">
                <td colspan="5" class="table-section">Allowed Uses</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">GAPI</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.state?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.county?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.city?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrGAPIGroupIdsStatistic?.total?.usesHashesCount | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">ZAPI</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.state?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.county?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.city?.usesHashesCount | number }}</td>
                <td>{{ zoningCodeRecord?.MetaData?.solrZAPIGroupIdsStatistic?.total?.usesHashesCount | number }}</td>
            </tr>
            <tr class="lower-height-row">
                <td class="title-cell">Difference</td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.state?.usesHashesCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.state?.usesHashesCount | number }}
                </td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.county?.usesHashesCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.county?.usesHashesCount | number
                    }}</td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.city?.usesHashesCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.city?.usesHashesCount | number }}
                </td>
                <td
                    ngClass="{{zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.total?.usesHashesCount != 0 ? 'red-text' : ''}}">
                    {{ zoningCodeRecord?.MetaData?.solrGAPIZAPIGroupIdsDiffStatistic?.total?.usesHashesCount | number }}
                </td>
            </tr>
            <tr class="lower-height-row">
                <td colspan="5" class="table-section">Calculation Results Statistic by Zoning Code Statuses</td>
            </tr>
            <ng-container *ngFor="let statistic of zcvCRCountByZCStatus" [ngTemplateOutlet]="zcvStatistic"
                [ngTemplateOutletContext]="{ statistic: statistic }"></ng-container>
        </tbody>
    </table>
</div>

<ng-template #zcvStatistic let-statistic="statistic">
    <tr class="lower-height-row">
        <td colspan="5" class="table-section">Zoning Code Version Id {{statistic.zcvId}}, Actual Version
            {{statistic.actualVersion || 'No Data'}}{{statistic.isLatest?'*':''}}</td>
    </tr>
    <tr class="lower-height-row">
        <td class="title-cell">Active</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.ACTIVE, 'state')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.ACTIVE, 'county')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.ACTIVE, 'city')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.ACTIVE, 'total')}}</td>
    </tr>
    <tr class="lower-height-row">
        <td class="title-cell">Draft</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.DRAFT, 'state')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.DRAFT, 'county')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.DRAFT, 'city')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.DRAFT, 'total')}}</td>
    </tr>
    <tr class="lower-height-row">
        <td class="title-cell">Inactive</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.INACTIVE, 'state')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.INACTIVE, 'county')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.INACTIVE, 'city')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.INACTIVE, 'total')}}</td>
    </tr>
    <tr class="lower-height-row">
        <td class="title-cell">In Testing</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.IN_TESTING, 'state')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.IN_TESTING, 'county')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.IN_TESTING, 'city')}}</td>
        <td>{{ getCountByStatusForZCVStr(statistic, zoningCodeStatus.IN_TESTING, 'total')}}</td>
    </tr>
</ng-template>
